import * as sessionTimer from './session-timer';

export default sessionTimer;
